module.exports = __webpack_public_path__ + "285809f6be76ab799a3875cffdc856b2.svg";